import { ModulesState } from '@pages/setup-summary/store/states/modules.state';

export const setupSummaryState = [ModulesState];
